// Simple API utility for FC Iveria
// Centralized API base URL configuration

export const getApiBaseUrl = () => {
  // Always use production domain for API calls
  return 'https://fciveria.ge';
};

export const getApiUrl = (endpoint) => {
  return `${getApiBaseUrl()}${endpoint}`;
};















